<template>
  <section class="newsletter-section content-padd" :class="{ isMobile }">
    <div class="news-content content-width">
      <div class="news-title">
        <h2 class="title-simple">
          Bądź na bieżąco <br />
          z aktualnościami GUNB
        </h2>
      </div>
      <div class="news-form-script" ref="edbNewsletter"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LibHomeSectionNewsletter",
  data() {
    return {
      checkbox: false,
      showForm: false,
    };
  },
  mounted() {
    var newsletterScript = document.createElement("script");
    newsletterScript.setAttribute("type", "text/javascript");
    newsletterScript.setAttribute(
      "src",
      "https://app.getresponse.com/view_webform_v2.js?u=MDzn8&webforms_id=wrgSk"
    );
    newsletterScript.setAttribute("data-webform-id", "wrgSk");
    this.$refs.edbNewsletter.appendChild(newsletterScript);
  },
};
</script>

<style lang="scss">
.newsletter-section {
  //background: var(--c-primary);
  background: #333399;
  color: #fff;
  overflow: hidden;
  position: relative;
  z-index: 2;

  .news-content {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    > div {
      flex: 1 0;
    }
  }

  .news-form {
    max-width: 680px;
    position: relative;
  }
  .news-form-script {
    max-width: 680px;
    position: relative;
  }

  @media (max-width: 1100px) {
    .news-content {
      display: block;
    }
  }

  .input-email {
    appearance: none;
    height: 48px;
    border: 1px solid var(--c-primary-blue);
    border-radius: 4px;
    padding: 0 38px 0 10px;
    background: #fff;
    outline: none;
    font-size: 1rem;
    font-weight: 500;
    width: 100%;
  }

  .v-input--checkbox {
    .v-input--selection-controls__input {
      margin-right: 22px;
    }
    .v-input__slot {
      align-items: flex-start;
    }
    .v-label {
      font-size: 0.875rem;
      color: #fff;
    }
  }

  .news-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  &.isMobile {
    .news-content {
      display: block;
    }
    .news-btns {
      display: flex;
      justify-content: flex-start;
      margin-top: 0px;
    }
  }
}
</style>
